import { Password } from "@mui/icons-material";
import _ from "../../../../@lodash";

const UserModel = (data) =>
  _.defaults(data || {}, {
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    role: "reviewer",
    organization: "",
    title: "",
    settings: {
      color: "#013BB1",
      dark_mode: false
    },
    active: true
  });

export default UserModel;
